import {AbstractControl, FormArray, FormControl, FormGroup, ValidationErrors} from '@angular/forms';

export type TypedForm<T> = FormGroup<{
    [P in keyof T]: T[P] extends Array<string | number | boolean | bigint>
        ? FormControl<T[P]>
        : T[P] extends any[]
            ? FormArray<TypedForm<T[P][number]>>
            : T[P] extends object
                ? T[P] extends Date
                    ? FormControl<T[P]>
                    : TypedForm<T[P]>
                : FormControl<T[P]>;
}>;

export function maxDateDifferenceValidator(
    startDateKey: string,
    endDateKey: string,
    maxDays: number,
) {
    return (control: AbstractControl): ValidationErrors | null => {
        const startDate = new Date(control.get(startDateKey)?.value);
        const endDate = new Date(control.get(endDateKey)?.value);

        if (startDate && endDate) {
            const differenceInTime = endDate.getTime() - startDate.getTime();
            const differenceInDays = differenceInTime / (1000 * 3600 * 24);

            if (differenceInDays > maxDays) {
                return {maxDateDifference: true};
            }
        }

        return null;
    };
}
